<template>
  <div>
    <div class="tabbarNew">
      <!-- <div class="customer-service-new" @click="showService=true" /> -->
      <div v-if="isshowcny==='1'" class="mons-change-new" @click="$router.push('/setMonsType')" />
      <div v-if="isshowdb==='1'" class="db-new" @click="goUrl(dburl)" />
      <van-tabbar v-model="active" :fixed="false" route>
        <van-tabbar-item v-for="(item ,index) in menuList" :id="index===3?'add-home-android':''" :key="index" :class="item.url===$route.path?'van-tabbar-item--active':''" @click="goTo(item.url,index)">{{ item.name }}
          <template #icon="props">
            <svg-icon :icon-class="index===2?(showService?item.iconActive:item.iconInactive):index===3?(showAddPhone?item.iconActive:item.iconInactive):(item.url===$route.path ? item.iconActive : item.iconInactive)" :width="20" :height="20" />
            <div v-if="index===4 && $route.query.suid" :class="'vip-level-'+vipLevel" />
          </template>

        </van-tabbar-item>

      </van-tabbar>

    </div>
    <van-popup v-model="showService">
      <customer-service @close="showService=false" />
    </van-popup>
    <van-popup v-model="showAddPhone" position="bottom">
      <!-- <div class="add-phone-tip-bg" @click="showAddPhone=false">
      </div> -->
      <img class="add-phone-tip-bg" :src="downloadImg" alt="" @click="showAddPhone=false">
    </van-popup>
    <!-- <van-popup v-model="showMenuList" position="bottom" :overlay="false">
      <menu-list @close="showMenuList=false;" />
    </van-popup> -->
  </div>
</template>

<script>
import variables from '@/styles/variables.scss'
import CustomerService from '@/views/portal/modules/CustomerService.vue'
// import MenuList from '@/views/portal/modules/MenuList.vue'
import { getToken } from '@/utils/auth'
import { getUInfoByToken } from '@/api/user'
export default {
  components: {
    CustomerService
  },
  data() {
    return {
      downloadImg: '',
      isshowcny: '',
      isshowdb: '',
      dburl: '',
      showAddPhone: false,
      showService: false,
      // showMenuList: false,
      active: 0,
      menuList: [
        // { url: '/menuList', iconActive: '菜单_s', iconInactive: '菜单_n', name: this.$t('bottomTab.zmk07') },
        { url: '/home', iconActive: 'bottom_首页_s' + process.env.VUE_APP_BASE_THEME, iconInactive: 'bottom_首页_n', name: this.$t('bottomTab.zmk01') },
        { url: '/activity', iconActive: 'bottom_活动_s' + process.env.VUE_APP_BASE_THEME, iconInactive: 'bottom_活动_n', name: this.$t('bottomTab.zmk02') },
        { url: '/showService', iconActive: 'bottom_客服_s' + process.env.VUE_APP_BASE_THEME, iconInactive: 'bottom_客服_n', name: this.$t('bottomTab.zmk08') },
        // { url: '/shareFriends', iconActive: 'bottom_推荐_s'+ process.env.VUE_APP_BASE_THEME, iconInactive: 'bottom_推荐_n', name: this.$t('bottomTab.zmk06') },
        { url: '/shareFriends', iconActive: 'bottom_下载_s' + process.env.VUE_APP_BASE_THEME, iconInactive: 'bottom_下载_n', name: this.$t('bottomTab.zmk14') },
        { url: '/user', iconActive: 'bottom_我的_s' + process.env.VUE_APP_BASE_THEME, iconInactive: 'bottom_我的_n', name: this.$t('bottomTab.zmk04') }
      ],
      vipLevel: '',
      deferredPrompt: null
    }
  },
  computed: {
    variables() {
      return variables
    }
  },
  created() {
    let params = {}
    if (this.$route.query.suid) {
      params = { dzhdid: this.$route.query.dzhdid, suid: this.$route.query.suid }
    } else {
      params = { dzhdid: this.$route.query.dzhdid }
    }
    getUInfoByToken(params).then(res => {
      this.isshowcny = res.isshowcny
      this.isshowdb = res.isshowdb
      this.dburl = res.dburl
      // debugger
      // if (process.env.VUE_APP_BASE_THEME === 'black-gold-theme') {
      //   this.downloadImg = res['downloadpopupgold']
      // } else {
      //   this.downloadImg = res['downloadpopup']
      // }
      this.downloadImg = res['downloadpopup']
      debugger
    })
    if (this.$store.getters.vipInfo && this.$store.getters.vipInfo.viplevel) {
      this.vipLevel = this.$store.getters.vipInfo.viplevel
    }
  },
  mounted() {
    // this.$bus.$on('showMenuPop', (data) => {
    //   this.showMenuList = data
    //   // if (this.showMenuList) {
    //   //   this.menuList[0].url = '/home'
    //   //   this.menuList[1].url = '/menuList'
    //   // } else {
    //   //   this.menuList[0].url = '/menuList'
    //   //   this.menuList[1].url = '/home'
    //   // }
    // })
    this.$bus.$on('showCustomer', (data) => {
      this.showService = data
    })
    // window.addEventListener('beforeinstallprompt', (e) => {
    //   debugger
    //   // 阻止默认行为并保存提示对象
    //   e.preventDefault();
    //   this.deferredPrompt = e;
    //   const ele = document.getElementById('add-home-android');
    //   // document.getElementById('add-home-android').style.display = 'block';
    //   ele.addEventListener('click', () => {
    //     if(this.deferredPrompt){
    //       debugger
    //       this.deferredPrompt.prompt(); // 显示安装提示框
    //       this.deferredPrompt.userChoice.then((choice) => {
    //         if (choice.outcome === 'accepted') {
    //           console.log('User accepted the A2HS prompt', choice);
    //         } else {
    //           console.log('User dismissed the A2HS prompt', choice);
    //         }
    //         this.deferredPrompt = null; // 重置提示对象，以便可以再次触发安装提示
    //       });
    //     }else{
    //       console.log('no prompt')
    //     }
    //   });
    // });
  },
  methods: {
    goTo(url, index) {
      if (index === 0 && this.$route.path === url) {
        this.showAddPhone = false
        this.showService = false
        this.$bus.$emit('returnHot')
      } else if (index === 3) {
        this.showService = false
        // if ('shortcut' in window.navigator) { // 检测是否支持旧版API
        //   window.navigator.shortcut.add('名称', 'URL', '', '图标URL', function() {
        //     console.log('Shortcut added');
        //   }, function(e) {
        //     console.log('Error in adding shortcut', e);
        //   });
        // } else
        // if ('install' in navigator) { // 检测是否支持install API（例如在某些版本的Chrome中）
        //   navigator.install(); // 触发安装提示（通常需要HTTPS环境）
        // } else {
        //   console.log('Shortcut API not supported');
        //   this.showAddPhone = !this.showAddPhone
        // }
        const userAgent = navigator.userAgent || navigator.vendor || window.opera
        if (userAgent.match(/Android/i)) {
          if (this.deferredPrompt) {
            this.deferredPrompt.prompt() // 显示安装提示框
            this.deferredPrompt.userChoice.then((choice) => {
              if (choice.outcome === 'accepted') {
                console.log('User accepted the A2HS prompt', choice)
              } else {
                console.log('User dismissed the A2HS prompt', choice)
              }
              this.deferredPrompt = null // 重置提示对象，以便可以再次触发安装提示
            })
          } else {
            this.$toast('已安装，若未安装请刷新页面后再试,或更换为chrome浏览器')
          }
        } else {
          this.showAddPhone = !this.showAddPhone
        }
      } else if (index === 1 || index === 3 || index === 4) {
        this.showAddPhone = false
        this.showService = false
        this.$store.getters.token ? (this.$router.push({ path: url + `?suid=` + getToken() || this.$store.getters.token })) : this.$toast(this.$t('bottomTab.zmk05'))
        // this.showMenuList = false
        // if (index === 1) {
        //   this.$bus.$emit('returnHot')
        // }
      } else if (index === 2) {
        this.showAddPhone = false
        this.showService = !this.showService
      } else {
        this.$router.push({ path: url })
      }
    },
    showTip() {
      this.$toast(this.$t('home.sy42'))
    },
    goUrl(url) {
      window.open(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.tabbarNew {
  width: 100vw;
  position: fixed;
  bottom: -40px;
  left: 0;
  z-index: 9999999;
  // border-top: 2px solid #f5f5f5;
}
.add-phone-tip-bg{
  height: 974px;
  width:750px;
  // background:var(--add-home-tip);
  background-size: cover;
  margin-bottom: 120px;
}
</style>
<style lang="less">
.customer-service-new{
  bottom:150px;
  right: 0;
  width: 112px;
  height: 112px;
  display: flex;
  position: fixed!important;
  z-index: 999;
  background-image: url('~@/assets/portal/联系客服.png');
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
}
.db-new{
  bottom:280px;
  right: 0;
  width: 112px;
  height: 112px;
  display: flex;
  position: fixed!important;
  z-index: 999;
  background-image: url('~@/assets/portal/金貝担保.png');
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
}
.mons-change-new{
  bottom:160px;
  right: 0;
  width: 112px;
  height: 112px;
  display: flex;
  position: fixed!important;
  z-index: 999;
  background-image: url('~@/assets/portal/button_筹码切换.png');
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
}
.mons-add-new{
  bottom:460px;
  right: 0;
  width: 112px;
  height: 112px;
  display: flex;
  position: fixed!important;
  z-index: 999;
  background: #e3e3e3 ;
}
.tabbarNew {
  .van-tabbar {
    // background: url('~@/assets/portal/bg_底部导航1.png') repeat-y top;
    // background-size: 100%;
    background: rgba(31,31,41,0.85);
    backdrop-filter: blur(10px);
    border: none;
    height:160px;
  }
  .van-tabbar-item {
    color: #c1c9e6;
    margin-bottom: 30px;
  }
  .van-tabbar-item--active {
    color: #fff;
    background-color: unset;
  }
  [class*=van-hairline]::after {
    border: none;
  }
  .vip-level-0 {
    position: absolute;
    top: 12px;
    right: -2px;
    width: 30px;
    height: 30px;
    background-image: url('~@/assets/portal/vipIcon/tag_vip0.webp');
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
  }
  .vip-level-1 {
    position: absolute;
    top: 12px;
    right: -2px;
    width: 30px;
    height: 30px;
    background-image: url('~@/assets/portal/vipIcon/tag_vip1.webp');
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
  }
  .vip-level-2 {
    position: absolute;
    top: 12px;
    right: -2px;
    width: 30px;
    height: 30px;
    background-image: url('~@/assets/portal/vipIcon/tag_vip2.webp');
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
  }
  .vip-level-3 {
    position: absolute;
    top: 12px;
    right: -2px;
    width: 30px;
    height: 30px;
    background-image: url('~@/assets/portal/vipIcon/tag_vip3.webp');
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
  }
  .vip-level-4 {
    position: absolute;
    top: 12px;
    right: -2px;
    width: 30px;
    height: 30px;
    background-image: url('~@/assets/portal/vipIcon/tag_vip4.webp');
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
  }
  .vip-level-5 {
    position: absolute;
    top: 12px;
    right: -2px;
    width: 30px;
    height: 30px;
    background-image: url('~@/assets/portal/vipIcon/tag_vip5.webp');
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
  }
  .vip-level-6 {
    position: absolute;
    top: 12px;
    right: -2px;
    width: 30px;
    height: 30px;
    background-image: url('~@/assets/portal/vipIcon/tag_vip6.webp');
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
  }
  .vip-level-7 {
    position: absolute;
    top: 12px;
    right: -2px;
    width: 30px;
    height: 30px;
    background-image: url('~@/assets/portal/vipIcon/tag_vip7.webp');
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
  }
  .vip-level-8 {
    position: absolute;
    top: 12px;
    right: -2px;
    width: 30px;
    height: 30px;
    background-image: url('~@/assets/portal/vipIcon/tag_vip8.webp');
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
  }
  .vip-level-9 {
    position: absolute;
    top: 12px;
    right: -2px;
    width: 30px;
    height: 30px;
    background-image: url('~@/assets/portal/vipIcon/tag_vip9.webp');
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
  }
  .vip-level-10 {
    position: absolute;
    top: 12px;
    right: -2px;
    width: 30px;
    height: 30px;
    background-image: url('~@/assets/portal/vipIcon/tag_vip10.webp');
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
  }
  .vip-level-11 {
    position: absolute;
    top: 12px;
    right: -2px;
    width: 30px;
    height: 30px;
    background-image: url('~@/assets/portal/vipIcon/tag_vip11.webp');
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
  }
  .vip-level-12 {
    position: absolute;
    top: 12px;
    right: -2px;
    width: 30px;
    height: 30px;
    background-image: url('~@/assets/portal/vipIcon/tag_vip12.webp');
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
  }
}
::-webkit-scrollbar{
  width: 10px;
  height: 10px;
  background: #013b8e;
}
// 滚动条
::-webkit-scrollbar {
  width: 6px;
  background-color: rgba(0, 0, 0, 0);
}
/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 10px;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: inherit;
  // background-color: rgba(144, 147, 153, 0.3);
  background-color: rgba(144, 147, 153, 0);
  -webkit-transition: 0.3s background-color;
  transition: 0.3s background-color;
}
</style>
